import React from 'react';
import LightningAnimation from './components/LightningAnimation';
import './styles.css';

function App() {
  return (
    <div className="App">
      <h1>⚡Lightning Algorithm⚡</h1>
      <LightningAnimation />
    </div>
  );
}

export default App;
